  export default[
      {
        path: "/dindvgmryghoiguerygjoidtunfy",
        children: [
          {
            path: "UFWNIUFGTIUVRTERE8TUREYEOIDYMENE",
            name: "bece25.grades",
            component: () => import("@/views/bece/twf/grades/list.vue"),
            meta: {
              title: "Bece grade(s)",
              authRequired: true,
              acc: ["y41288"],
            },
          },
          {
            path: "NYHJOFUDIUFYHGREOUUT7YW05UERTUGHTHENTUUT",
            name: "bece25.upload.grades",
            component: () => import("@/views/bece/twf/grades/upload.vue"),
            meta: {
              title: "Upload Bece Grade(s)",
              authRequired: true,
              acc: ["y41288"],
            },
          },
        //   {
        //     path: "GVNHERREOWHWI5UT0TEYRHRNUNRYTJ3O5UTUYTER",
        //     name: "bece.update.grades.25",
        //     component: () => import("../views/bece/grades/update.vue"),
        //     meta: {
        //       title: "Update Bece Grade(s)",
        //       authRequired: true,
        //       acc: ["y41288"],
        //     },
        //   },
          {
            path: "JEBHVRWTHERITITYRTWY3T8UNYRTHEBERBORWURWRTTERITH",
            name: "bece25.export.grades",
            component: () => import("@/views/bece/twf/grades/export.vue"),
            meta: {
              title: "Export Bece Grade(s)",
              authRequired: true,
              acc: ["y41288"],
            },
          },
        ],
      },
  ]